import { useState } from "react";
import { Info } from "lucide-react";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { C } from "./profileTheme";

export function InfoTip({
  text,
  disabled,
}: {
  text: string;
  disabled?: boolean;
}) {
  const [open, setOpen] = useState(false);

  if (disabled) {
    return (
      <Info
        size={11}
        className="inline-block ml-1 shrink-0 opacity-40 pointer-events-none"
        style={{ color: C.dim }}
        aria-hidden
      />
    );
  }

  return (
    <Tooltip open={open} onOpenChange={setOpen}>
      <TooltipTrigger asChild>
        <Info
          size={11}
          className="inline-block ml-1 cursor-help shrink-0"
          style={{ color: C.dim }}
          onClick={e => {
            e.stopPropagation();
            setOpen(v => !v);
          }}
        />
      </TooltipTrigger>
      <TooltipContent
        className="max-w-xs text-xs"
        style={{
          background: C.card2,
          border: `1px solid ${C.border}`,
          color: C.text,
        }}
      >
        {text}
      </TooltipContent>
    </Tooltip>
  );
}
